import React, { Component } from 'react';
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import { Grid, Typography, Divider } from '@material-ui/core';

import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";

import Article from './common/Article';
import { formatNumber } from './common/utilities';

// styles
import imagesStyles from "assets/jss/material-kit-pro-react/imagesStyles.jsx";
import cardStyles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx"

// other assets
import { cardTitle } from "assets/jss/material-kit-pro-react.jsx";

const styles = () => ({
    ...imagesStyles,
    ...cardStyles,
    cardTitle,
    articleTitle: {'line-height': '1.2em'},
    contentSection: {
        flex: '1 1 auto',
        overflow: 'auto',
        zIndex: 1,
        position: 'relative',
        maxWidth: '95% !important',
        "@media screen and (max-width: 1200px)": {
            margin: "0 auto",
            marginTop: "50px",
            float: null,
            width: '100%'
        }
    },
    cardGrid: {marginTop: '0'},
})

class NewsFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        // const { classes } = this.props;

        // const rotatingCards = document.getElementsByClassName(classes.cardRotate);
        // for (let i=0; i<rotatingCards.length; i++) {
        //     const rotatingCard = rotatingCards[i],
        //         cardWidth = rotatingCard.parentElement.offsetWidth,
        //         cardHeight = rotatingCard.children[0].children[0].offsetHeight;

        //     let rotatingWrapper = rotatingCard.parentElement,
        //         cardFront = rotatingCard.getElementsByClassName(classes.front)[0],
        //         cardBack = rotatingCard.getElementsByClassName(classes.back)[0];

        //     rotatingWrapper.style.height = cardHeight + "px";
        //     rotatingWrapper.style["margin-bottom"] = 30 + "px";
        //     cardFront.style.height = cardHeight + 35 + "px";
        //     cardFront.style.width = cardWidth + "px";
        //     cardBack.style.height = cardHeight + 35 + "px";
        //     cardBack.style.width = cardWidth + "px";
        // }
    }

    renderItem(record, subjects) {
        return (
            <Article 
                key={record.data_id} 
                isGrant={false} 
                record={record}
                subjects={subjects}
                utcStart={this.props.utcStart} />
        )
    }

    render () {
        const { classes } = this.props;
        const { totalRecords, queryTerm, isFetching, records, subjectFilters } = this.props.data;
        let { title } = this.props;

        if (title === undefined || title === null) {
            title = records && records.length ? 
                `Showing ${formatNumber(records.length)} articles out of ${formatNumber(totalRecords)} available results` 
                : null
        }

        return (
            <Grid item xs={12} md={8} className={classes.contentSection}>
                <Typography variant="title" gutterBottom>
                    { title }
                    {queryTerm.length ? ` for ${queryTerm.replace(/\\"/g, '"')}` : ''}
                </Typography>
                <Divider />
                {
                    isFetching ? 
                        <CustomLinearProgress color="primary" />
                        : <Grid container spacing={40} className={`${classes.cardGrid} ${classes.cardGrid}`}  alignItems="stretch" direction="row" justify="center">
                            { 
                                records ? 
                                    records.map((record, index) => this.renderItem(record, subjectFilters)) : 
                                    undefined 
                            }
                        </Grid>
                }
            </Grid>
        )
    }
}

NewsFeed.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object,
    totalRecords: PropTypes.number,
    queryTerm: PropTypes.string,
    isFetching: PropTypes.bool,
    records: PropTypes.array,
    utcStart: PropTypes.instanceOf(Date)
}

export default withStyles(styles)(NewsFeed);


// WEBPACK FOOTER //
// ./src/components/Article/MainFeed.jsx